// tslint:disable
import { Injector, Component } from '@angular/core';

import { CMFormBrowse2Component, CMFormPesquisaComponent, CMInputConfig } from './../../@cmcore/component';
import { ContaBancariaEditComponent } from './conta-bancaria-edit.component';
import { HttpClient } from '@angular/common/http';
import { FuncsGlobais } from '../funcs.globais';

@Component({
  selector: 'conta-bancaria-browse',
  templateUrl: './../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.html',
  styleUrls: ['./../../@cmcore/component/cmform/cmform-browse/cmform-browse2.component.scss']
})
export class ContaBancariaBrowseComponent extends CMFormBrowse2Component {

  static defaultColumns = [{field: 'codigo', caption: '#', filter: true},
  {field: 'descricao',   caption: 'Descrição', filter: true},
  {field: 'codigobanco', caption: 'Código do Banco', filter: true},
  {field: 'sped', caption: 'Gera Sped', filter: true}
];

  constructor(_injector: Injector) {
      super(_injector);
      this.controllerName = 'ContaBancaria';
      this.formEditComponent = ContaBancariaEditComponent;
      this.fixedFooterFormEdit = false;
      this.columns = ContaBancariaBrowseComponent.defaultColumns;
    }
  
  getTitle() {
  return 'Conta Bancária';
  }

  static pesquisa(
    sender: any,
    target: any,
    tipo: string,
    targetProp?: string,
    onAfterSelect?: Function,
    extraFilters?: Object,
    extraColumns?: Array<any>
  ) {
    if (target) {
      let columns = [
        { field: "codigo", caption: "#", filter: true},
        {
          field: "descricao",
          caption: "Descricao",
          filter: new CMInputConfig({
            maxlength: 60,
          }),
        }
      ];
      if (extraColumns) {
        extraColumns.forEach((column) => {
          columns.push(column);
        });
      }
      CMFormPesquisaComponent.defaultPesquisa(
        sender,
        "contabancaria",
        "Pesquisa de " + tipo,
        columns,
        target,
        targetProp,
        "codigo",
        onAfterSelect,
        undefined,
        undefined,
        extraFilters
      );
    }
  }
}
